import { render, staticRenderFns } from "./KoioteButtonFeedback.vue?vue&type=template&id=60210bae&scoped=true"
import script from "./KoioteButtonFeedback.vue?vue&type=script&lang=js"
export * from "./KoioteButtonFeedback.vue?vue&type=script&lang=js"
import style0 from "./KoioteButtonFeedback.vue?vue&type=style&index=0&id=60210bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60210bae",
  null
  
)

export default component.exports